import * as React from 'react';

import { Button } from '@acceligentllc/storybook';

import styles from './styles.module.scss';

type Props = {
	onDeleteClick: () => void;
	icon?: string;
};

const DeleteCell: React.FC<Props> = ({ onDeleteClick, icon }) => {
	return (
		<div className={styles['delete-cell']}>
			<Button icon={icon ? icon : 'Delete'} onClick={onDeleteClick} style="link-danger" />
		</div>
	);
};

export default React.memo(DeleteCell);
